<template>
  <div class="sa-list-component" style="height: 100% !important; padding: 8px;">
    <div class="sa-list-component-header">
    </div>
    <div class="sa-list-component-body">
      <b-card class="sa-card sa-card-border sa-card-list-scroll" header-tag="header" footer-tag="footer" title="">
        <template #header>
          <div class="d-flex justify-content-between align-items-center custom-header">
            <span>Impegnativa e dettaglio prestazioni</span>
            <b-button size="sm" variant="success" @click="onClickAggiungiImpegantiva"
              :disabled="!isEdit">Aggiungi</b-button>
          </div>
        </template>
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="localData.ricette"
            :fields="headersImpegnative" :current-page="1" :per-page="100" sort-icon-left head-variant="light"
            class="sa-b-table" empty-text="no data" :sort-compare="sortCompare" sort-by="createDate" :sort-desc="true">
            <template v-slot:cell(tipologia)="row">
              <span style="font-weight: 700; margin-right: 3px">{{ row.item.tipologia }}</span>
            </template>
            <template v-slot:cell(nre)="row">
              <span style="font-weight: 700; " v-if="row.item.codiceBar1 != 'PVT'">
                <span style="width:100%; display: inline-block;">{{ row.item.codiceBar1 }} {{ row.item.codiceBar2
                  }}</span>
              </span>
              <span v-else>
                <span style="font-weight: 700; width:100%; display: inline-block;">{{
                  row.item.codiceBar1 }} </span>
                <span style="font-weight: 700; width:100%; display: inline-block;">
                  {{ row.item.codiceBar2
                  }}</span>
              </span>

            </template>
            <template v-slot:cell(prestazioni)="row">
              <span style="font-weight: 700; margin-right: 3px">
                {{ row.item.prestazioni ? row.item.prestazioni.length : 0 }}
              </span>
            </template>
            <template v-slot:cell(nominativo)="row">
              <span style="font-weight: 500; margin-right: 3px">
                {{ row.item.nome }} {{ row.item.cognome }}
                <br />
                <small> {{ row.item.codiceFiscaleAssistito }}</small>
              </span>

            </template>
            <template v-slot:cell(statoAttuale)="row">
              <span style="font-weight: 500; margin-right: 1px" v-if="completeBookingSsn">{{ row.item.statoAttuale
                }}</span>
              <div v-else>
                <span v-html="getCicloDescrizione(row)"></span>
                <br />
                <i>{{ row.item.statoAttuale
                  }}</i>
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <b-container style="gap:8px; display: flex;">
                <b-button @click="onClickInfoRicetta(row)" title="Prestazioni e ciclo"
                  variant="btn btn-secondary waves-effect waves-light width-sm no-text">
                  <b-icon icon="info-circle"></b-icon>
                </b-button>
                <b-button @click="onClickVisualizzaRicetta(row)" title="Visualizza Ricetta"
                  variant="btn btn-info waves-effect waves-light width-sm no-text">
                  <b-icon icon="eye"></b-icon>
                </b-button>
                <b-button @click="onClickModificaRicetta(row)" title="Modifica Ricetta"
                  variant="btn btn-primary waves-effect waves-light width-sm no-text">
                  <b-icon icon="pencil"></b-icon>
                </b-button>
                <b-button v-if="component || isEdit" @click="onClickRimuoviRicetta(row)" title="Elimina Ricetta"
                  variant="btn btn-danger waves-effect waves-light width-sm no-text">
                  <font-awesome-icon :icon="'trash'" />
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
      </b-card>
    </div>
    <accettazione-ssn-impegnativa-modal-component ref="mdlAccettaazioneImpegnativa" :isEdit="isEdit"
      :codiceFiscalePaziente="codiceFiscalePaziente" @onAggiungiImpegnativa="onAggiungiImpegnativa"
      @onModificaImpegnativa="onModificaImpegnativa" @reload="onReload" />
    <!-- info: prestazioni e ciclo della ricetta, come nel dettaglio della lista accettazioni -->
    <b-modal ref="mdlInfoRicetta" title="Prestazioni e ciclo" size="lg" centered @hidden="ricettaInfo = null">
      <!-- altezza fissa: se il contenuto è più lungo scorre qui dentro -->
      <div class="ft-info-ricetta">
        <accettazione-ssn-ricetta-dettaglio-component v-if="ricettaInfo" :ricetta="ricettaInfo" accessiAperti pallini />
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$refs.mdlInfoRicetta.hide()">Chiudi</b-button>
      </template>
    </b-modal>
  </div>

</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnImpegnativaModalComponent from "./AccettazioneSsnImpegnativaModalComponent.vue";
import AccettazioneSsnRicettaDettaglioComponent from "./AccettazioneSsnRicettaDettaglioComponent.vue";
import axios from "axios";
import toast from "../../../../template/layout/utility/sa-toast.js";

/*
 * Tabella delle impegnative con la modale di inserimento/modifica.
 * Usato da: AccettazioneSsnEditViewPage, AccettazioneSsnRiepilogoImpegnativeListPage (appuntamenti),
 * AccettazionePazienteImpegnativePage (rsa).
 *
 * Eventi: onAggiungiImpegnativa(ricetta, integrazioneNre), reload, ricetteLoad(lista).
 * Metodi pubblici: loadRicette(filtro), showImpegnativa(ricetta), apriNuovaImpegnativa().
 */
export default {
  components: { AccettazioneSsnImpegnativaModalComponent, AccettazioneSsnRicettaDettaglioComponent },
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [UtilityMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    component: {
      type: Boolean,
      default: false,
    },
    idAccettazione: {
      type: String,
      default: null,
    },
    jsonData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    ricette: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      localData: {
        ricette: [],
      },
      ricettaInModifica: null,
      ricettaInfo: null,
      completeBookingSsn: this.appConfig.completeBookingSSN,
      headersImpegnative: [
        {
          label: "Tipologia",
          key: "tipologiaRicetta",
        },
        {
          label: "Nominativo",
          key: "nominativo",
        },
        {
          label: "Priorità",
          key: "classePriorita",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "Stato Ricetta",
          key: "statoAttuale",
        },
        {
          label: "Qnt. Prestazioni",
          key: "prestazioni",
        },
        {
          label: "Data Creazione",
          key: "createDate",
          thStyle: "width: 8rem",
          formatter: (v) => {
            return this.formatDateTime(v);
          }
        },
        {
          label: "",
          key: "actions",
          class: "sa-table-column-action-double",
          thStyle: "width: 8rem",
          thClass: "text-right",
          tdClass: "text-right"
        }
      ],
    };
  },

  computed: {
    codiceFiscalePaziente() {
      return this.jsonData?.accettazione?.accettazioneAnagrafica?.identificativo ?? null;
    },
  },

  mounted() {
    this.setJsonData();
    if (!this.completeBookingSsn) {
      let header = this.headersImpegnative.find(e => e.key == 'statoAttuale');
      header.label = 'Ciclo Ricetta'
    }
  },

  watch: {
    ricette: function () {
      this.setJsonData();
    },
  },

  methods: {
    setJsonData() {
      // stesso array del padre: le modifiche alla lista arrivano direttamente al chiamante
      this.localData.ricette = this.ricette;
    },
    loadRicette(filtro) {
      this.openShowModalLoading();
      let link = process.env.VUE_APP_PATH_API + "/accettazionericette";
      axios
        .get(link, { params: { ...filtro } })
        .then((response) => {
          this.localData.ricette = response.data.data.list;
          this.$emit("ricetteLoad", response.data.data.list)
          this.closeShowModalLoading();
        })
        .catch((error) => {
          this.closeShowModalLoading();
          toast.error(error?.response?.data?.messaggio);
        });
    },
    sortCompare(aRow, bRow, key) {
      if (key === 'createDate') {
        const aDate = new Date(aRow[key]);
        const bDate = new Date(bRow[key]);
        return aDate - bDate;
      }
      return false; // fallback al comportamento di default per le altre colonne
    },
    getCicloDescrizione(row) {
      let countAccessiEseguiti = 0;
      (row.item.prestazioni || []).forEach(element => {
        countAccessiEseguiti += element.appuntamenti ? element.appuntamenti.length : 0;
      });
      return `${countAccessiEseguiti}/${row.item.quantitaErogabile}`
    },

    onClickAggiungiImpegantiva() {
      this.$refs.mdlAccettaazioneImpegnativa.init(this.jsonData.accettazione)
    },
    apriNuovaImpegnativa() {
      this.$refs.mdlAccettaazioneImpegnativa.showDematerializzata(this.jsonData);
    },
    onClickModificaRicetta(row) {
      this.ricettaInModifica = row.item;
      this.$refs.mdlAccettaazioneImpegnativa.setRicettaModificare(row, this.jsonData);
      this.$refs.mdlAccettaazioneImpegnativa.show();
    },
    onClickVisualizzaRicetta(row) {
      this.$refs.mdlAccettaazioneImpegnativa.setRicettaVisualizzazione(row, this.jsonData);
      this.$refs.mdlAccettaazioneImpegnativa.show();
    },
    onClickInfoRicetta(row) {
      this.ricettaInfo = row.item;
      this.$refs.mdlInfoRicetta.show();
    },
    showImpegnativa(ricetta) {
      this.$nextTick(() => {
        this.$refs.mdlAccettaazioneImpegnativa.setRicetta(ricetta, this.jsonData);
      });
    },

    onAggiungiImpegnativa(ricetta, integrazioneNre) {
      this.$emit("onAggiungiImpegnativa", ricetta, integrazioneNre);
    },
    onModificaImpegnativa(ricetta) {
      // l'indice della riga è quello della tabella ordinata, quindi si cerca la ricetta originale
      const index = this.localData.ricette.indexOf(this.ricettaInModifica);
      if (index > -1) {
        this.$set(this.localData.ricette, index, ricetta);
      }
      this.ricettaInModifica = null;
      this.$refs.mdlAccettaazioneImpegnativa.hide();
    },
    onReload() {
      this.$emit("reload");
    },

    onClickRimuoviRicetta(row) {
      this.$bvModal
        .msgBoxConfirm(`sei sicuro di voler eliminare ricetta: ${row.item.codiceBar1} ${row.item.codiceBar2}`, {
          title: "Eliminazione Ricetta",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.eliminaRicetta(row);
          }
        })
        .catch((err) => {
          err;
        });
    },
    eliminaRicetta(row) {
      const rimuoviDaLista = () => {
        const index = this.localData.ricette.indexOf(row.item);
        if (index > -1) {
          this.localData.ricette.splice(index, 1);
        }
      };

      // ricetta non ancora salvata: basta toglierla dalla lista
      if (!row.item.id || row.item.id == "-1") {
        rimuoviDaLista();
        return;
      }

      axios
        .delete(process.env.VUE_APP_PATH_API + "/accettazionericette" + "/" + row.item.id)
        .then(() => {
          rimuoviDaLista();
          toast.success("Ricetta eliminata con successo");
          this.$emit("reload");
        })
        .catch((err) => {
          toast.error(err?.response?.data?.messaggio);
        });
    },
  },
};
</script>

<style>
.ft-card {
  border: 1px solid #b6b5b5 !important;
  border-radius: 12px;
  padding: 2px;
  transition: all 0.1s linear;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  background: #ffffff;
  cursor: pointer;
}

.ft-card .card-body {
  padding: 5px !important;
}

.ft-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.ftActiveClass,
.ftActiveClass:hover {
  box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
  border: 2px solid #00a3ff !important;
  border-color: #00a3ff !important;
}
</style>

<style scoped>
.sa-card-list-scroll {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.sa-card-list-scroll ::v-deep .card-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sa-card-list-scroll .b-table-sticky-header {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* modale info ricetta: dimensione fissa, scroll interno */
.ft-info-ricetta {
  height: 480px;
  overflow-y: auto;
}
</style>
